export const nextPageAccessor = (lastPage, allPages) => {
    const hasNextPage = lastPage && lastPage[0]?.has_next_page;
    return hasNextPage ? allPages.length + 1 : undefined;
};
//# sourceMappingURL=nextPageAccessor.js.map